module.exports = __webpack_public_path__ + "static/media/storie_03.cd9ad2d9.jpg";